import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import useActionAllowedInArea from "../../auth/hooks/useActionAllowedInArea";
import { getBrandById } from "../api/getBrandById";

export const useBrandQuery = (brandId: string) => {
  const readAccess = useActionAllowedInArea("brandsAndPages", "read");
  return useQuery({
    queryKey: ["brand", brandId],
    queryFn: async () => {
      return await getBrandById(brandId);
    },
    enabled: Boolean(readAccess.allowed),
  });
};

export const invalidateBrandQuery = (brandId: string) => {
  return queryClient.invalidateQueries({
    queryKey: ["brand", brandId],
  });
};
